import { useEffect } from 'react';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import {
  StyledTestDurationHoursInputs,
  StyledPaddedCriteriaWrapper,
  StyledInputText,
  StyledInputWrapper,
  StyledDurationLabel,
  StyledErrorMessage,
} from 'modules/experiments/components/pages/edit/sections/settings/styled';
import { UpdateExperimentSettingsFormFieldNames } from 'modules/experiments/constants/updateExperimentSettings';
import {
  DEFAULT_TEST_DURATION_HOURS,
  DEFAULT_TEST_DURATION_MINUTES,
} from 'modules/experiments/takeover/constants';

const transformToNumber = (v: string) => (v === '' ? null : Number(v));

export const WinningCriteriaTestDurationForm = () => {
  const { t } = useExperimentsTranslations();

  const { TEST_DURATION_HOURS, TEST_DURATION_MINUTES } = UpdateExperimentSettingsFormFieldNames;

  const { field: testDurationHoursField } = useController({
    name: TEST_DURATION_HOURS,
  });

  const { field: testDurationsMinsField } = useController({
    name: TEST_DURATION_MINUTES,
  });

  const [watchTestDurationHours, watchTestDurationMins] = useWatch({
    name: [TEST_DURATION_HOURS, TEST_DURATION_MINUTES],
  });

  const {
    trigger,
    formState: { errors },
  } = useFormContext();

  const hasErrors = !!(errors[TEST_DURATION_HOURS] || errors[TEST_DURATION_MINUTES]);

  useEffect(() => {
    trigger();
  }, [watchTestDurationHours, watchTestDurationMins]);

  return (
    <StyledPaddedCriteriaWrapper data-test="winning-criteria-test-duration-form">
      <StyledDurationLabel>{t('settings.winningCriteria.selectWinnerAfter')}</StyledDurationLabel>
      <StyledInputWrapper>
        <StyledTestDurationHoursInputs
          isHorizontalLayout
          hasError={hasErrors}
          inputId="test-duration-hours"
        >
          <StyledInputText
            data-test={'test-duration-hours'}
            name={TEST_DURATION_HOURS}
            value={testDurationHoursField.value}
            type="number"
            id="test-duration-hours"
            Suffix={'hours'}
            placeholder={`${DEFAULT_TEST_DURATION_HOURS}`}
            onBlur={testDurationHoursField.onBlur}
            onChange={(v: string) => testDurationHoursField.onChange(transformToNumber(v))}
          />
          <StyledInputText
            data-test={'test-duration-minutes'}
            name={TEST_DURATION_MINUTES}
            value={testDurationsMinsField.value}
            type="number"
            id="test-durations-minutes"
            Suffix={'minutes'}
            placeholder={`${DEFAULT_TEST_DURATION_MINUTES}`}
            onBlur={testDurationsMinsField.onBlur}
            onChange={(v: string) => testDurationsMinsField.onChange(transformToNumber(v))}
          />
        </StyledTestDurationHoursInputs>
        {hasErrors && (
          <StyledErrorMessage>
            {/* @ts-expect-error */}
            {errors[TEST_DURATION_HOURS]?.message || errors[TEST_DURATION_MINUTES]?.message}
          </StyledErrorMessage>
        )}
      </StyledInputWrapper>
    </StyledPaddedCriteriaWrapper>
  );
};
